import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Button
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";

import { Helmet } from "react-helmet-async";

import { FiChevronDown } from "react-icons/fi";

import useStyles from "./styles";
import TextInput from "Components/TextInput";
import Spinner from "Components/Spinner";

import actions from "store/actions";

import _ from "lodash";

import ls from "Localization";
import { State } from "store/reducers";
import AutoComplete from "Components/AutoComplete";
import { SubscriptionEditState } from "store/reducers/subscription/edit";
import { UserState } from "store/reducers/user";
import { MONEY } from "Components/NumberFormat";
import Select from "Components/Select";
import { SubscriptionStatus } from "Types/Subscription";
import { useNavigate } from "react-router-dom";

let debounceFindUser: (() => any) & _.Cancelable;
let debounceFindPayer: (() => any) & _.Cancelable;

function SubscriptionEdit({ match }: any) {
	const navigate = useNavigate();
	const dispatch = useDispatch<any>();
	const classes = useStyles({});

	const [showInfoPanel, setShowInfoPanel] = useState(true);

	useEffect(() => {
		dispatch(actions.subscription.edit.clearValues());
	}, [dispatch]);

	useEffect(() => {
		dispatch(actions.subscription.edit.getSubscription(match.params.id));
	}, [dispatch, match.params.id]);

	const { loading: userLoading } = useSelector<State, UserState>(s => s.user);

	const subscription = useSelector<State, SubscriptionEditState>(
		s => s.subscriptionEdit
	);

	if (subscription.loading) {
		return null;
	}

	const { loading, errors, description, value, status, user }: any =
		subscription;

	const handleChange = (id: string, value: any) => {
		const v = { [id]: value };
		dispatch(actions.subscription.edit.setValue(v));
	};

	const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		dispatch(
			actions.subscription.edit.updateSubscription((err, model) => {
				if (err) {
					if (err.code) {
						alert(err.code);
					} else if (typeof err === "string") alert(err);
					else alert(JSON.stringify(err));
				} else {
					navigate("/Dashboard/Subscriptions");
				}
			})
		);
	};

	const findUser = (name: any, callback: any) => {
		if (name.length >= 3) {
			if (debounceFindUser) debounceFindUser.cancel();

			debounceFindUser = _.debounce(() => {
				dispatch(
					actions.user.getUsers(
						0,
						10,
						`&filters[searchText]=${name}&filters[roles]=mei`,
						undefined,
						false,
						false,
						(errors, models) => {
							if (models) {
								callback(
									models.map(c => ({
										id: c._id,
										label: `${c.name} ${c.lastname}`
									}))
								);
							} else {
								callback([]);
							}
						}
					)
				);
			}, 1000);

			debounceFindUser();
		}
	};

	const findPayer = (name: any, callback: any) => {
		if (name.length >= 3) {
			if (debounceFindPayer) debounceFindPayer.cancel();

			debounceFindPayer = _.debounce(() => {
				dispatch(
					actions.user.getUsers(
						0,
						10,
						`&filters[searchText]=${name}&filters[roles]=logisticOperator`,
						undefined,
						false,
						false,
						(errors, models) => {
							if (models) {
								callback(
									models.map(c => ({
										id: c._id,
										label: `${c.name} ${c.lastname}`
									}))
								);
							} else {
								callback([]);
							}
						}
					)
				);
			}, 1000);

			debounceFindPayer();
		}
	};

	const ls2: any = ls;

	return (
		<form onSubmit={handleSubmit} noValidate>
			<Helmet>
				<title>
					{ls.subscriptionEdit} | {ls.appName}
				</title>
			</Helmet>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Accordion
						TransitionProps={{ unmountOnExit: true }}
						expanded={showInfoPanel}
						onChange={() => setShowInfoPanel(prev => !prev)}
					>
						<AccordionSummary
							expandIcon={<FiChevronDown />}
							aria-controls="finishes-content"
							id="finishes-header"
						>
							<Typography className={classes.heading} variant="h6">
								{ls.subscriptionEdit}
							</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<Grid container spacing={2}>
								<Grid item xs={12} sm={6} md={4} lg={3}>
									<AutoComplete
										id="user"
										name="user"
										errors={errors}
										defaultValue={
											user
												? {
														id: user._id,
														label: `${user.name} ${user.lastname}`
												  }
												: null
										}
										onChange={handleChange}
										loadOptions={findUser}
										loading={userLoading}
										filterOptions={(options: any, state: any) => {
											return options;
										}}
									/>
								</Grid>

								<Grid item xs={12} sm={6} md={4} lg={3}>
									<TextInput
										errors={errors}
										id="value"
										name="value"
										value={value}
										required
										onChange={handleChange}
										InputProps={{
											inputComponent: MONEY
										}}
									/>
								</Grid>
								<Grid item xs={12} sm={6} md={4} lg={3}>
									<Select
										errors={errors}
										id="status"
										name="status"
										value={status.toString()}
										required
										onChange={handleChange}
										options={[
											{ id: "", value: ls.noneSelectedText, disabled: true },
											...Object.keys(SubscriptionStatus)
												.filter(c => !isNaN(+c))
												.map((c: any) => ({
													id: c,
													value: ls2[SubscriptionStatus[c]]
												}))
										]}
									/>
								</Grid>
								<Grid item xs={12}>
									<TextInput
										errors={errors}
										id="description"
										name="description"
										value={description}
										required
										onChange={handleChange}
									/>
								</Grid>
							</Grid>
						</AccordionDetails>
					</Accordion>
				</Grid>

				<Grid item xs={12}>
					<Grid container justifyContent="flex-end">
						<Grid item>
							<Button
								disabled={loading}
								variant="contained"
								color="secondary"
								type="submit"
							>
								Salvar
								{loading && <Spinner size={20} style={{ marginLeft: 16 }} />}
							</Button>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</form>
	);
}

export default SubscriptionEdit;
